import {IAsyncUploaderFileMeta} from './IAsyncUploaderFileMeta';
import {IListener} from '../Events';
import {IAsyncUploaderQueuedFile} from './IAsyncUploaderQueuedFile';
import {ISubscription} from '../Events/ISubscription';

export enum Events {
    ALL = 'async-uploader.*',
    PUSH = 'async-uploader.push',
    FILE_ADDED_TO_LIST = 'async-uploader.file-added-to-list',
    FILE_REMOVED_FROM_LIST = 'async-uploader.file-removed-from-list',
    REMOVE = 'async-uploader.remove',
    ABORT = 'async-uploader.abort',
    PAUSE = 'async-uploader.pause',
    RESUME = 'async-uploader.resume',
    STATUS_RECEIVED = 'async-uploader.status',
    STATUS_UPDATED = 'async-uploader.status-updated',
    SEND = 'async-uploader.send',
    PROGRESS = 'async-uploader.progress',
    SUCCESS = 'async-uploader.success',
    FAIL = 'async-uploader.fail',
    COMPLETE = 'async-uploader.complete',
    ERROR_OCCURRED = 'async-uploader.error-occurred',
}

export interface IAsyncUploader {
    getProgress(): number;

    getProgressOfItem(uniqueId: string): number;

    getMaxNumberOfParallelUploads(): number;

    setMaxNumberOfParallelUploads(number: number): void;

    getItems(): IAsyncUploaderQueuedFile[];

    getItem(uniqueId: string): IAsyncUploaderQueuedFile | null;

    getItemByServerHash(serverHash: string): IAsyncUploaderQueuedFile | null;

    getItemsToLoad(): IAsyncUploaderQueuedFile[];

    getLoadingNowItems(): IAsyncUploaderQueuedFile[];

    getFile(uniqueId: string): File | null;

    getMeta(uniqueId: string): IAsyncUploaderFileMeta | null;

    push(file: File, context?: IAsyncUploaderFileMeta['context']): IAsyncUploaderQueuedFile;

    has(uniqueId: string): boolean;

    remove(uniqueId: string): boolean;

    pause(uniqueId: string): boolean;

    resume(uniqueId: string): boolean;

    abort(uniqueId: string): boolean;

    listen<TPayload>(event: Events | Events[], listener: IListener<TPayload>): ISubscription;
}
